import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { mergeEntity, mergeEntities } from '@utils/object.js'

export const initialState = {}

function getDefaultAttributes() {
  return {}
}
const defaultAttributes = getDefaultAttributes()

export const group = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_GROUP, (state, action) => receiveGroup(state, action))
    .addCase(ActionTypes.RECEIVE_GROUPS, (state, action) => receiveGroups(state, action))
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
})

export default group

function receiveGroups(state, action) {
  const { payload: groups } = action
  return mergeEntities(state, groups, defaultAttributes)
}

function receiveGroup(state, action) {
  const { payload: group } = action
  return mergeEntity(state, group, defaultAttributes)
}

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('group')) {
    const { group: entity } = payload
    state = mergeEntity(state, entity, defaultAttributes)
  }
  if (payload.hasOwnProperty('groups')) {
    const { groups: entities } = payload
    state = mergeEntities(state, entities, defaultAttributes)
  }
  return state
}
